// yyyymmdd <-> Date conversions shared across the Adherence Report page,
// table, and chart — kept in one place so the two representations of a date
// never drift out of sync.

export const intToDate = (dateKey: number): Date => {
  const year = Math.floor(dateKey / 10000)
  const month = Math.floor((dateKey % 10000) / 100) - 1 // month is 0-based
  const day = dateKey % 100
  return new Date(year, month, day)
}

export const dateToInt = (date: Date): number =>
  Number(
    date.getFullYear().toString() +
      String(date.getMonth() + 1).padStart(2, '0') +
      String(date.getDate()).padStart(2, '0')
  )
